import React, { useState, useEffect } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalBody, VStack, Text, Button, Input } from '@chakra-ui/react'

interface WorkEmailVerificationModalProps {
  isOpen: boolean
  onClose: () => void
  onSkip: () => void
  onSubmit?: (email: string) => void
  isLoading?: boolean
  deadlineDate: string
  isPastDeadline?: boolean
  initialEmail?: string
}

const WorkEmailVerificationModal: React.FC<WorkEmailVerificationModalProps> = ({
  isOpen,
  onClose,
  onSkip,
  onSubmit,
  isLoading = false,
  deadlineDate,
  isPastDeadline = false,
  initialEmail = ''
}) => {
  const [workEmail, setWorkEmail] = useState(initialEmail)

  useEffect(() => {
    setWorkEmail(initialEmail)
  }, [initialEmail])

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit(workEmail)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={() => {}} closeOnOverlayClick={false} closeOnEsc={false} isCentered>
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent maxW="400px" borderRadius="16px" p={6} mx={4}>
        <ModalBody p={0}>
          <VStack spacing={2} align="center">
            <VStack spacing={1}>
              <Text fontSize="18px" fontWeight="600" color="gray.900" textAlign="center">
                Verify Your Work Email
              </Text>

              <Text fontSize="14px" color="gray.900" textAlign="center" lineHeight="1.5" px={2}>
                To proceed with Single Sign-On, please bind and verify your work email before <b>{deadlineDate}</b> to
                continue using the system.
              </Text>
            </VStack>
            <VStack w={'100%'}>
              <Input
                placeholder="Enter your work email"
                value={workEmail}
                onChange={e => setWorkEmail(e.target.value)}
                type="email"
                fontSize="16px"
                h="40px"
                borderRadius="8px"
                borderColor="gray.300"
                _focus={{
                  borderColor: 'primary.500',
                  boxShadow: '0 0 0 1px #00A9EB'
                }}
                _placeholder={{
                  color: 'gray.400'
                }}
              />
              <Button
                w="100%"
                h="40px"
                bg={isPastDeadline ? '#FFA500' : '#00A9EB'}
                color="white"
                borderRadius="12px"
                border={'none'}
                fontSize="16px"
                fontWeight="600"
                _hover={{ bg: isPastDeadline ? '#E6940A' : '#0088CC' }}
                _active={{ bg: isPastDeadline ? '#CC8500' : '#006699' }}
                onClick={handleSubmit}
                isDisabled={!workEmail || !workEmail.includes('@') || isLoading}
              >
                {isLoading ? 'Sending...' : isPastDeadline ? 'Verify Email' : 'Submit'}
              </Button>

              {!isPastDeadline && (
                <Button
                  h="40px"
                  variant="outline"
                  color="gray.600"
                  fontSize="16px"
                  fontWeight="500"
                  _hover={{ bg: 'gray.50' }}
                  onClick={onSkip}
                  border={'none'}
                  borderRadius="12px"
                  backgroundColor={'white'}
                  isDisabled={isLoading}
                >
                  Skip
                </Button>
              )}
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default WorkEmailVerificationModal
